export const primary = {
  50: "#fbe6e2",
  100: "#f5c3b8",
  200: "#ef9c8b",
  300: "#e9735d",
  400: "#e4513a",
  500: "#cb4c2b",
  600: "#b64427",
  700: "#9d3b22",
  800: "#842f1c",
  900: "#651f11"
};